import TeacherWelcome from './TeacherWelcome';

export { TeacherWelcome };
export default TeacherWelcome;
